import { AccessibilityItem } from '@/types'
import { ListItem, Header, CommentLink } from './Accessibility.styles'
import Icon from './Icons'
import { Spacing, Icon as CommonUiIcon } from '@big-red-group/storefront-common-ui'
import { useTheme } from 'styled-components'

const Accessibility: React.FC<{ content: AccessibilityItem[]; productId: number }> = ({ content, productId }) => {
  const theme = useTheme()
  const checkboxItems = content.filter((item) => !item.comment)
  const commentItems = content.filter((item) => item.comment)

  const isDigitsOnly = (value: string) => {
    return /^-?\d+$/.test(value)
  }

  return (
    <ul>
      {checkboxItems.map(({ id, label }) => (
        <ListItem key={id} itemType="checkboxItem">
          <Header>
            <Icon name="circleTick" stroke={theme?.colourPalette?.primaryColour || '#FCC703'} />
            {label}
          </Header>
        </ListItem>
      ))}
      {commentItems.map(({ id, label, comment }) => (
        <ListItem key={id} itemType="checkboxItem">
          <Header>
            <CommonUiIcon name="infoFilled" viewBox="0 0 32 33" />
            {label}
          </Header>
          <Spacing size="M" />
          {comment &&
            // todo: fix this once Loki structure has changed
            (isDigitsOnly(comment) ? (
              <CommentLink
                href={`https://cdn.experienceoz.com.au/assets/product/${productId}/newImage/${comment}.jpg`}
                target="_blank"
              >
                <Icon name="link" /> View here
              </CommentLink>
            ) : (
              <p>{comment}</p>
            ))}
        </ListItem>
      ))}
    </ul>
  )
}

export default Accessibility
